import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { states } from "@parkschannel/map";
import { Button, InputUI, Typography } from "@parkschannel/ui";
import { AdvancedFiltersNavigationHeader } from "../AdvancedFiltersComponents";
import { DebouncedSearch } from "../../../../Forms/DebouncedSearch";
export function AdvancedFiltersStates(param) {
    let { onBack , onFilter , initialStates  } = param;
    const [search, setSearch] = useState("");
    const [filteredStates, setFilteredStates] = useState(states);
    const { register , handleSubmit  } = useForm({
        defaultValues: {
            selectedStates: initialStates
        }
    });
    const onSubmit = (data)=>{
        onFilter(data.selectedStates);
    };
    const onSearch = (value)=>{
        if (!value) return setSearch("");
        setSearch(value);
    };
    useEffect(()=>{
        setFilteredStates(states.filter((state)=>state.value.toLowerCase().includes(search.toLowerCase())));
    }, [
        search
    ]);
    return /*#__PURE__*/ _jsxs("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "h-[100%] flex flex-col justify-between",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "grow max-h-[calc(100%-40px)]",
                children: [
                    /*#__PURE__*/ _jsx(AdvancedFiltersNavigationHeader, {
                        onBack: onBack,
                        title: /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyLarge",
                            className: "text-neutral-700",
                            children: "Choose states"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ _jsx(DebouncedSearch, {
                            placeholder: "Search for anything",
                            value: search,
                            onChange: onSearch
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 w-full max-h-[calc(100%-124px)] overflow-y-auto p-2 flex flex-col gap-6",
                        children: filteredStates.map((state)=>/*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx(InputUI.CheckBox, {
                                    id: state.value,
                                    htmlFor: state.value,
                                    type: "checkbox",
                                    value: state.value,
                                    text: state.label,
                                    ...register("selectedStates")
                                })
                            }, state.value))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-4 w-full",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "base",
                        onClick: onBack,
                        children: "Back"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        className: "w-full",
                        children: "Add Filter"
                    })
                ]
            })
        ]
    });
}
